/* eslint-disable global-require */ // --> OFF
/* eslint-disable no-underscore-dangle */ // --> OFF
import Vue from 'vue';
import { Icon } from 'leaflet';
import VueSvgGauge from 'vue-svg-gauge';
import Vuetify from 'vuetify/lib';
import 'leaflet/dist/leaflet.css';
import App from './App.vue';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all';
// import VueLayers from 'vuelayers'
import router from './router';
import store from './store/index';
// import "vuelayers/lib/style.css"; // needs css-loader
import './assets/css/main.css';
// Vue.use(VueLayers);
Vue.config.productionTip = false;

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.use(VueSvgGauge);
Vue.use(Vuetify);

new Vue({
  icons: {
    iconfont: 'fa',
  },
  router,
  store,
  vuetify: new Vuetify({
    theme: { dark: false },
  }),
  render: (h) => h(App),
}).$mount('#app');
